/**
 * 本地/内网开发域名判定（oneIDContext 取测试 companyUUID 兜底用）。
 */
export default function isLocalDevHost() {
  try {
    var hostname = window.location.hostname;
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      /^10\./.test(hostname) ||
      /^192\.168\./.test(hostname) ||
      /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)
    );
  } catch (e) {
    return false;
  }
}
